import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TournamentEndResult } from "../../../../shared/models";
import { CurrencyInfo } from "../../../../shared/models/currency-info";

export interface TournamentEndDialogCantobyteData {
  tournamentEndResult: TournamentEndResult;
  currencyInfo: CurrencyInfo;
}

@Component({
  selector: "app-tournament-end-dialog-cantobyte",
  templateUrl: "./tournament-end-dialog-cantobyte.component.html",
  styleUrls: ["./tournament-end-dialog-cantobyte.component.scss"],
})
export class TournamentEndDialogCantobyteComponent {
  constructor(
    public dialogRef: MatDialogRef<TournamentEndDialogCantobyteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TournamentEndDialogCantobyteData,
  ) {}

  get hasPrize(): boolean {
    return (this.data.tournamentEndResult?.Value2 ?? 0) > 0;
  }

  get playerName(): string {
    return this.data.tournamentEndResult?.PlayerData?.Name ?? "";
  }

  get position(): number {
    return this.data.tournamentEndResult?.Value ?? 0;
  }

  get totalPlayers(): number {
    return (
      this.data.tournamentEndResult?.TournamentSummary?.NbPlayerRegistered ?? 0
    );
  }

  close(): void {
    this.dialogRef.close();
  }

  goToLobby(): void {
    this.dialogRef.close(true);
  }
}
